import ModelDistribution from "./ModelDistribution";
import {keys} from "../config/nameSpacesKeys";

export default class ModelDistributionList {
  constructor(name, initialValue, namespace) {
    this.namespace=namespace;
    this.name=name;

    this.distributionsList=[];
    if (initialValue) {
      this.parseInputJSON(initialValue);
    } else {
      this.addValueObj();
    }
  }

  getNameSpace() {
    return this.namespace;
  }

  getDistributionsList() {
    return this.distributionsList;
  }

  setDistributionsList(fdistributionsList) {
    this.distributionsList=fdistributionsList;
  }

  removeValueObj(item, index) {
    if (index<0 || index>=this.distributionsList.length) {
      return;
    }
    this.distributionsList.splice(index, 1);
  }

  addValueObj(obj) {
    const distribution = new ModelDistribution(this.name, obj, this.namespace,
        keys.title,
        keys.distributionMethod,
        keys.accessLevel,
        keys.amountOfActiveParameters,
        keys.tokensPerParameter,
        keys.accessLocation,
        keys.format,
        keys.size);
    this.distributionsList.push(distribution);
  }

  parseInputJSON(inputJSON) {
    // const obj=inputJSON[this.namespace];
    const obj=inputJSON;
    // console.log(inputJSON, this.namespace);
    if (Array.isArray(obj)) {
      for (const entry of Object.entries(obj)) {
        const value=entry[1];
        this.addValueObj(value);
      }
    } else {
      this.addValueObj(obj);
    }
  }

  getExpandedFormatValue() {
    const expandedList=[];
    for (let index=0; index<this.distributionsList.length; index++) {
      const distributionItem=this.distributionsList[index];
      expandedList.push(distributionItem.getExpandedFormatValue());
    }
    return expandedList;
  }

  isEmpty() {
    let condition=true;
    for (let index=0; index<this.distributionsList.length; index++) {
      const distributionItem=this.distributionsList[index];
      condition=condition&&distributionItem.isEmpty();
    }
    return condition;
  }
}
